import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ViewportService } from '../services/viewport.service';
import { DefaultLandingService } from '../services/default-landing.service';

@Injectable({
  providedIn: 'root'
})
export class MobileGuard implements CanActivate {
  constructor(
    private router: Router,
    private viewport: ViewportService,
    private defaultLanding: DefaultLandingService
  ) {}

  canActivate(): boolean {
    // User chose Quick Actions as home — allow landing even on desktop.
    if (this.defaultLanding.getPreference() === 'landing') {
      return true;
    }
    if (this.viewport.shouldUseKilnListRoute()) {
      this.router.navigate(['/kiln-list']);
      return false;
    }
    return true;
  }
}
